<template>
    <div class="pro-form-card">
        <div class="pro-form-header">
            <!-- <div class="header-left">
                <v-icon class="primary-color-assuraf mr-2">&#xe7ee;</v-icon>
                <div class="titles">
                    <h3 class="title">{{ $t('assur_lead.form_assur_lead.title') }}</h3>
                    <p class="subtitle">{{ $t('assur_lead.form_assur_lead.subheading') }}</p>
                </div>
            </div> -->
            <div class="header-right">
              <v-icon class="primary-color-assuraf mr-2">&#xe7ee;</v-icon>
                <span class="badge">{{ $t('assur_lead.form_assur_lead.first_step.header_right') }}</span>
            </div>
        </div>

        <h3 class="title-margin" v-if="currentStep === 1">{{ $t('assur_lead.form_assur_lead.first_step.subtitle') }} <span>1/2</span></h3>
        <h3 class="title-margin" v-if="currentStep === 2">{{ $t('assur_lead.form_assur_lead.second_step.subtitle') }} <span v-if="!identifiant">2/2</span></h3>
        <!-- Bloc LeadAgent -->
        <div v-if="currentStep === 1 && !identifiant" class="mt-5">
            <div class="fields">
                <div class="row">
                    <div class="col-sm-6">
                        <div class="field-group field-default mb-4 mb-sm-0">
                            <label class="field-label">{{ $t('assur_lead.form_assur_lead.first_step.nom_complet_label') }} <span class="required-asterisk">*</span></label>
                            <input v-model="lead_agent_nom" @input="validateField('lead_agent_nom')" :class="['field-input', { invalid: !!errors.lead_agent_nom }]" :placeholder="$t('assur_lead.form_assur_lead.first_step.nom_complet_placeholder')" name="lead_agent_nom">
                            <small v-if="errors.lead_agent_nom" class="error-msg">{{ errors.lead_agent_nom }}</small>
                        </div>
                    </div>
                    <div class="col-sm-6">
                        <div class="field-group field-default mb-4 mb-sm-0">
                            <label class="field-label">{{ $t('assur_lead.form_assur_lead.first_step.numero_telephone_label') }} <span class="required-asterisk">*</span></label>
                            <div class="phone-input-group">
                                <CountryCodeSelect v-model="countryCode" />
                                <input v-model="lead_agent_number" @input="validateField('lead_agent_number')" @keypress="onlyNumber" :class="['field-input', { invalid: !!errors.lead_agent_number }, 'phone-number-input']" :placeholder="$t('assur_lead.form_assur_lead.first_step.numero_telephone_placeholder')" name="lead_agent_number" :readonly="!!identifiant">
                            </div>
                            <small v-if="errors.lead_agent_number" class="error-msg">{{ errors.lead_agent_number }}</small>
                        </div>
                    </div>
                </div>
            </div>

            <!-- Bouton pour passer à l'étape suivante -->
            <div class="actions">
                <button @click="currentStep = 2" type="button" class="wizard-btn next-btn" :class="{'next-btn-active': isStep1Complete}" :disabled="!isStep1Complete">
                    <span class="mr-2">{{ $t('assur_lead.form_assur_lead.first_step.next_button_label') }}</span>
                    <v-icon>&#xe5c8;</v-icon>
                </button>
            </div>
        </div>
        <!-- Bloc Lead -->
        <div v-if="currentStep === 2" class="mt-5">
            <div class="fields">
                <div class="row">
                    <div class="col-sm-4">
                        <div class="field-group field-default mb-4 mb-sm-0">
                            <label class="field-label">{{ $t('assur_lead.form_assur_lead.second_step.nom_complet_label') }} <span class="required-asterisk">*</span></label>
                            <input v-model="lead_nom" @input="validateField('lead_nom')" :class="['field-input', { invalid: !!errors.lead_nom }]" :placeholder="$t('assur_lead.form_assur_lead.second_step.nom_complet_placeholder')" name="lead_nom">
                            <small v-if="errors.lead_nom" class="error-msg">{{ errors.lead_nom }}</small>
                        </div>
                    </div>
                     <div class="col-sm-4">
                        <div class="field-group field-default mb-4 mb-sm-0">
                            <label class="field-label">{{ $t('assur_lead.form_assur_lead.second_step.numero_telephone_label') }} <span class="required-asterisk">*</span></label>
                            <div class="phone-input-group">
                                <CountryCodeSelect v-model="countryCode" />
                                <input v-model="telephone_lead" @input="validateField('telephone_lead')" @keypress="onlyNumber" :class="['field-input', { invalid: !!errors.telephone_lead }, 'phone-number-input']" :placeholder="$t('assur_lead.form_assur_lead.second_step.numero_telephone_placeholder')" name="telephone_lead">
                            </div>
                            <small v-if="errors.telephone_lead" class="error-msg">{{ errors.telephone_lead }}</small>
                        </div>
                    </div>
                     <div class="col-sm-4">
                        <div class="field-group field-default mb-4 mb-sm-0">
                            <label class="field-label">{{ $t('assur_lead.form_assur_lead.second_step.adresse_email_label') }}</label>
                            <input v-model="email_lead" @input="validateField('email_lead')" :class="['field-input', { invalid: !!errors.email_lead }]" :placeholder="$t('assur_lead.form_assur_lead.second_step.adresse_email_placeholder')" name="email_lead">
                            <small v-if="errors.email_lead" class="error-msg">{{ errors.email_lead }}</small>
                        </div>
                    </div>
                </div>
            </div>

            <div class="fields">
                <div class="row">
                    <div class="col-sm-3">
                        <div class="field-group field-default mb-4 mb-sm-0">
                            <label class="field-label">
                              {{ $t('assur_lead.form_assur_lead.second_step.immatriculation_label') }}
                              <span class="required-asterisk" v-if="!carte_grise_file">*</span>
                            </label>
                            <input maxlength="10" v-model="immatriculation_lead" @input="validateField('immatriculation_lead')" :class="['field-input', { invalid: !!errors.immatriculation_lead }]" :placeholder="$t('assur_lead.form_assur_lead.second_step.immatriculation_placeholder')" name="immatriculation_lead">
                            <small v-if="errors.immatriculation_lead" class="error-msg">{{ errors.immatriculation_lead }}</small>
                        </div>
                    </div>
                    <div class="col-sm-3">
                        <div class="field-group field-default mb-4">
                            <label class="field-label">Carte grise (recto)</label>
                            <input type="file" accept="image/*,.pdf" @change="onCarteGriseChange" class="field-input" name="carte_grise">
                            <small class="error-msg" v-if="errors.carte_grise">{{ errors.carte_grise }}</small>
                            <small class="helper-msg">{{ $t('assur_lead.form_assur_lead.second_step.upload_text_label') }}</small>
                            <div v-if="carte_grise_file" class="mt-2">
                                <span>{{ carte_grise_file.name }}</span>
                                <button type="button" class="wizard-btn back-btn ml-2" @click="removeCarteGrise">{{ $t('assur_lead.form_assur_lead.second_step.retirer_button_label') }}</button>
                            </div>
                        </div>
                    </div>
                    <div class="col-sm-3">
                        <div class="field-group field-default mb-4">
                            <label class="field-label">Carte grise (verso)</label>
                            <input type="file" accept="image/*,.pdf" @change="onCarteGriseVersoChange" class="field-input" name="carte_grise_verso">
                            <small class="error-msg" v-if="errors.carte_grise_verso">{{ errors.carte_grise_verso }}</small>
                            <div v-if="carte_grise_verso_file" class="mt-2">
                                <span>{{ carte_grise_verso_file.name }}</span>
                                <button type="button" class="wizard-btn back-btn ml-2" @click="removeCarteGriseVerso">{{ $t('assur_lead.form_assur_lead.second_step.retirer_button_label') }}</button>
                            </div>
                        </div>
                    </div>
                    <div class="col-sm-3">
                        <div class="field-group field-default mb-4 mb-sm-0">
                            <label class="field-label">{{ $t('assur_lead.form_assur_lead.second_step.date_effet_label') }}</label>
                            <input type="date" v-model="date_effet_lead" @input="validateField('date_effet_lead')" :class="['field-input', { invalid: !!errors.date_effet_lead }]" name="date_effet_lead" :min="minDate">
                            <small v-if="errors.date_effet_lead" class="error-msg">{{ errors.date_effet_lead }}</small>
                        </div>
                    </div>
                </div>
            </div>

            <!-- Bouton retour en arriere et Bouton d'envoi de la demande -->
            <div class="actions step2-actions">
                <button v-if="!identifiant" @click="currentStep = 1" type="button" class="wizard-btn back-btn">
                    <v-icon>&#xe5c4;</v-icon>
                    <span class="ml-2">{{ $t('assur_lead.form_assur_lead.second_step.back_button_label') }}</span>
                </button>
              <button v-else type="button" class="wizard-btn back-btn">

              </button>
                <button @click="sending_message" type="button" class="ml-3 wizard-btn send-btn" :disabled="hasErrors || !isFormComplete || isLoading">
                    <v-progress-circular v-if="isLoading" indeterminate color="#000000de" size="24" class="mr-2"></v-progress-circular>
                    <v-icon v-else class="send-icon">&#xe163;</v-icon>
                    <span>{{ isLoading ? $t('assur_lead.form_assur_lead.second_step.loading_message') : $t('assur_lead.form_assur_lead.second_step.send_button_label') }}</span>
                </button>
            </div>
        </div>

        <p class="required"><span class="required-asterisk">*</span> {{ $t('assur_lead.form_assur_lead.required_field_label') }}</p>
        <!-- Dialog Validation OTP -->
        <v-dialog v-model="otpDialog" persistent max-width="500px">
            <v-card class="otp-card pa-4">
                <div class="text-xs-right">
                    <v-btn icon small @click="closeOtpDialog">
                        <v-icon>&#xe5cd;</v-icon>
                    </v-btn>
                </div>

                <v-card-title class="headline font-weight-bold justify-center pt-0 pb-3">{{ $t('assur_lead.otp_form.title') }}</v-card-title>
                <v-card-text class="text-xs-center subheading grey--text text--darken-1">
                    {{ $t('assur_lead.otp_form.subtitle[0]') }} <strong>{{ displayPhoneNumber }}</strong>, {{ $t('assur_lead.otp_form.subtitle[1]') }}
                </v-card-text>

                <div class="otp-inputs-container my-4">
                    <input v-for="(digit, index) in otpDigits" :key="index" :ref="'otpInput' + index" type="text" maxlength="1" class="otp-input" v-model="otpDigits[index]" @input="onOtpInput(index, $event)" @keydown.delete="onOtpBackspace(index, $event)" @paste="onOtpPaste"/>
                </div>

                <!-- Bouton d'envoi -->
                <v-card-actions class="justify-center pb-4">
                    <v-btn block large color="#ffa409" class="otp-validate-button white--text font-weight-bold text-capitalize" :disabled="!isOtpComplete || isOtpLoading" @click="verifyOtp">
                        <v-progress-circular v-if="isOtpLoading" indeterminate color="white" size="24"></v-progress-circular>
                        <span v-else>{{ $t('assur_lead.otp_form.validation_button_label') }}</span>
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
    </div>
</template>

<script>
import Api from '../../services/Api';
import CountryCodeSelect from '../../views/CountryCodeSelectProOnline.vue'
import IntlNumber from '../../common/intlNumber.json'
import { parsePhoneNumberFromString } from 'libphonenumber-js'

// Valide un numéro selon l'indicatif sélectionné (via libphonenumber-js)
// Retourne un objet { valid, error } utilisable par la validation de formulaire.
const validatePhoneWithIndicatif = (phone, countryCode) => {
    try {
        const countryObj = IntlNumber.find(item => item.code === countryCode);
        const country = countryObj ? countryObj.iso2 : 'SN';
        const phoneNumber = parsePhoneNumberFromString(phone, country);
        if (phoneNumber && phoneNumber.isValid()) {
            return { valid: true, error: null };
        }
        return { valid: false, error: `Le numéro n'est pas valide pour ${countryCode}` };
    } catch (e) {
        return { valid: false, error: `Le numéro n'est pas valide pour ${countryCode}` };
    }
};

// Même validation que validatePhoneWithIndicatif, mais avec un format de retour dédié au lead agent.
const validatePhoneWithIndicatifLeadAgent = (phone, countryCode) => {
    try {
        const countryObj = IntlNumber.find(item => item.code === countryCode);
        const country = countryObj ? countryObj.iso2 : 'SN';
        const phoneNumber = parsePhoneNumberFromString(phone, country);
        if (phoneNumber && phoneNumber.isValid()) {
            return { valLeadAgent: true, errors: null };
        }
        return { valLeadAgent: false, errors: `Le numéro n'est pas valide pour ${countryCode}` };
    } catch (e) {
        return { valLeadAgent: false, errors: `Le numéro n'est pas valide pour ${countryCode}` };
    }
};

export default {
    name: 'LeadForm',
    components: {
        CountryCodeSelect
    },
    props: {
        identifiant: {
            type: String,
            default: null
        }
    },
    data: () => ({
        isLoading: false,
        isOtpLoading: false,
        otpDialog: false,
        otpDigits: ['', '', '', '', '', ''],
        countryCode : '+221',
        currentStep: 1,
        telephone_lead: '',
        email_lead: '',
        lead_nom: '',
        immatriculation_lead: '',
        date_effet_lead: '',
        lead_agent_nom: '',
        //lead_agent_prenom: '',
        lead_agent_number: '',
        carte_grise_file: null,
        carte_grise_verso_file: null,
        confirmCloseDialog: false,
        errors: {
            lead_agent_nom: null,
            //lead_agent_prenom: null,
            lead_agent_number: null,
            lead_nom: null,
            immatriculation_lead : null,
            telephone_lead: null,
            email_lead: null,
            carte_grise: null,
            carte_grise_verso: null,
        },
      ToastTabSucess: {
            theme: 'toasted-primary',
            position: 'top-center',
            duration: 4000,
            fitToScreen: true,
            type: 'success',
            className: 'custom-success-class'
        },
        ToastTabError: {
            theme: 'toasted-primary',
            position: 'top-center',
            duration: 4000,
            fitToScreen: true,
            type: 'error'
        },
    }),

    created() {
        if (this.identifiant) {
            this.currentStep = 2;
            this.fetchLeadAgentData();
            this.lead_agent_number = this.identifiant;
        }
    },

    computed: {
        // Date minimale utilisable par l'input type="date" (format YYYY-MM-DD)
        minDate() {
            return new Date().toISOString().split('T')[0]
        },
        // Numéro affiché dans le dialog OTP
        displayPhoneNumber() {
            if (this.identifiant) {
                return `${this.countryCode} ${this.telephone_lead}`;
            }
            return `${this.countryCode} ${this.lead_agent_number}`;
        },
        // Indique si les 6 champs OTP sont tous remplis
        isOtpComplete() {
            return this.otpDigits.every(d => d !== '' && d !== null && d !== undefined)
        },
        // True si au moins un champ a une erreur de validation
        hasErrors() {
            return Object.values(this.errors).some(v => !!v)
        },
        // Contrôle minimal pour la complétude des champs (étape 1)
        isStep1Complete() {
            // Variante simple (présence des champs seulement) :
            return !!this.lead_agent_nom && !!this.lead_agent_number && !this.errors.lead_agent_number
        },
        // Contrôle minimal de la complétude des champs (étape 2)
        isStep2Complete() {
            const hasIdOrFile = !!this.immatriculation_lead || !!this.carte_grise_file
            const base = !!this.telephone_lead && hasIdOrFile && !this.errors.telephone_lead
            return base
        },
        // Indique si le formulaire est complet (en fonction de l'étape)
        isFormComplete() {
            return this.currentStep === 1 ? this.isStep1Complete : this.isStep2Complete
        }
    },

    watch: {
        countryCode() {
            // Revalider le téléphone lorsqu’on change l’indicatif
            this.validateField('telephone_lead')
        }
    },

    methods: {
        // Récupère les données du lead agent et pré-remplit le formulaire
        async fetchLeadAgentData() {
            if (!this.identifiant) return;

            this.isLoading = true;
            try {
                const response = await Api().get(`/assurlead/lead-agent/${this.identifiant}`);
                if (response.data) {
                    this.lead_agent_nom = response.data.nom_complet;
                    this.lead_agent_number = response.data.telephone;
                }
            } catch (error) {
              console.log("Erreur lors de la récupération des données de l'agent")
                //this.$toasted.show("Erreur lors de la récupération des données de l'agent", this.ToastTabError);
            } finally {
                this.isLoading = false;
            }
        },

        // Empêche la saisie de caractères non numériques (utilisé sur certains champs)
        onlyNumber($event) {
            let NumOnly = ($event.NumOnly ? $event.NumOnly : $event.which);
            if ((NumOnly < 48 || NumOnly > 57) && NumOnly !== 46) {
                $event.preventDefault();
            }
        },
        // Validation simple d'email (format)
        validEmail(email) {
            return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)
        },
        // Ouvre la modal de confirmation avant fermeture du formulaire
        showCloseConfirmation() {
            this.confirmCloseDialog = true
        },
        // Confirme la fermeture: ferme le parent + reset du formulaire
        confirmClose() {
            this.confirmCloseDialog = false
            this.$emit('close')
            this.resetForm()
        },
        // Validation "bloquante" rapide avec toasts (utile avant navigation/submit)
        validateProFields() {
            if (!this.lead_agent_nom) { this.$toasted.show('Le nom est obligatoire', this.ToastTabError); return false; }
            if (!this.lead_agent_prenom) { this.$toasted.show('Le prénom est obligatoire', this.ToastTabError); return false; }
            if (!this.lead_agent_number) { this.$toasted.show('Le numéro est obligatoire', this.ToastTabError); return false; }
            return true;
        },
        // Valide un champ et renseigne this.errors[field] (null si OK, message sinon)
        validateField(field) {
            const val = this[field]
            switch (field) {
                case 'lead_agent_nom':
                    this.errors[field] = val ? null : 'Champ obligatoire'
                    break

                case 'lead_agent_number':
                    const validationResult = validatePhoneWithIndicatifLeadAgent(this.lead_agent_number, this.countryCode)
                    this.errors[field] = validationResult.valLeadAgent ? null : (validationResult.errors || 'Téléphone invalide')
                    break

                case 'lead_nom':
                    this.errors[field] = val ? null : 'Champ obligatoire'
                    break

                case 'telephone_lead':
                const { valid, error } = validatePhoneWithIndicatif(this.telephone_lead, this.countryCode)
                    this.errors[field] = valid ? null : (error || 'Téléphone invalide')
                    break

                case 'immatriculation_lead':
                    this.errors[field] = (this.carte_grise_file || val) ? null : 'Champ obligatoire (si carte grise non fournie)';
                    if (val && !this.errors[field]) {
                        const oldPlateRegex = /^[a-zA-Z0-9]{2}-[a-zA-Z0-9]{4}-[a-zA-Z0-9]{2}$/i;
                        const newPlateRegex = /^[a-zA-Z0-9]{2}-[a-zA-Z0-9]{3}-[a-zA-Z0-9]{2}$/i;
                        if (val.length > 10) {
                            this.errors[field] = 'Format incorrect (max 10 caractères)';
                        } else if (!oldPlateRegex.test(val) && !newPlateRegex.test(val)) {
                            this.errors[field] = 'Format incorrect (doit être XX-XXXX-XX ou XX-XXX-XX)';
                        }
                    }
                    break

                // case 'email_lead':
                //     this.errors[field] = val && this.validEmail(val) ? null : 'Email invalide'
                //     break
            }
        },
        // Gestion du fichier de carte grise
        onCarteGriseChange(e) {
            const file = e.target.files && e.target.files[0] ? e.target.files[0] : null
            this.carte_grise_file = file
            // Revalider l'immatriculation en fonction de la présence du fichier
            this.validateField('immatriculation_lead')
        },
        onCarteGriseVersoChange(e) {
            const file = e.target.files && e.target.files[0] ? e.target.files[0] : null
            this.carte_grise_verso_file = file
        },
        removeCarteGrise() {
            this.carte_grise_file = null
            this.validateField('immatriculation_lead')
        },
        removeCarteGriseVerso() {
            this.carte_grise_verso_file = null
        },
        // Exécute la validation sur les champs importants du formulaire
        runValidation() {
            const fields = ['telephone_lead', 'immatriculation_lead', 'lead_nom'];
            if (!this.identifiant) {
                fields.push('lead_agent_nom', 'lead_agent_number');
            }
            fields.forEach(f => this.validateField(f));
        },
        // Ferme le dialog OTP et réinitialise les 6 inputs
        closeOtpDialog() {
            this.otpDialog = false
            this.otpDigits = ['', '', '', '', '', '']
        },
        // Gère la saisie OTP: chiffres uniquement + auto-focus vers le champ suivant
        onOtpInput(index, event) {
            const value = event.target.value
            if (!/^\d*$/.test(value)) {
                this.otpDigits[index] = ''
                return
            }
            if (value.length === 1 && index < 5) {
                this.$refs['otpInput' + (index + 1)][0].focus()
            }
        },
        // Gère le retour arrière dans l'OTP: focus au champ précédent si vide
        onOtpBackspace(index, event) {
            if (event.key === 'Backspace' && !this.otpDigits[index] && index > 0) {
                this.$refs['otpInput' + (index - 1)][0].focus()
            }
        },
        // Support du collage d'un OTP complet (6 chiffres)
        onOtpPaste(event) {
            event.preventDefault()
            const clipboardData = event.clipboardData || window.clipboardData
            const pastedData = clipboardData.getData('Text')
            if (/^\d{6}$/.test(pastedData)) {
                this.otpDigits = pastedData.split('')
                this.$refs['otpInput5'][0].focus()
            }
        },
        // Demande un OTP pour le lead (client final)
        async requestLeadOtp() {
            this.isLoading = true;
            try {
                // Utiliser l'identifiant de l'URL s'il est présent, sinon le numéro saisi.
                const agentIdentifier = this.identifiant || this.lead_agent_number;

                await Api().post('/assurlead/lead/request-phone-verification', {
                    telephone_lead_agent: agentIdentifier,
                    telephone: this.telephone_lead
                });
                this.otpDialog = true;
                this.$toasted.show('Un code de vérification a été envoyé au client.', this.ToastTabSucess);
            } catch (error) {
                if (error.response && error.response.data && error.response.data.message) {
                    this.$toasted.show(error.response.data.message, this.ToastTabError);
                } else {
                    this.$toasted.show("Erreur lors de l'envoi de l'OTP au client.", this.ToastTabError);
                }
            } finally {
                this.isLoading = false;
            }
        },

        // Déclenche l'envoi d'une demande de vérification (OTP) pour le lead agent
        numberVerification(){
            let phoneNumber = (this.countryCode + this.lead_agent_number).substring(1)
            let numberData = {
                telephone_lead_agent: phoneNumber,
                nom_lead_agent: this.lead_agent_nom
            }

            //API de verification du lead Agent
            Api().post('/assurlead/lead-agent/request-verification', numberData)
                .then(response => {
                    this.otpDialog = true
                })
                .catch(error => {
                    this.$toasted.show('Erreur lors de l\'envoi de la demande', this.ToastTabError);
                });
        },

        // Vérifie le code OTP saisi puis, si OK, lance la création du lead
        async verifyOtp() {
            this.isOtpLoading = true;
            const code = this.otpDigits.join('');

            try {
                if (this.identifiant) {
                    // Scénario 2: Vérification de l'OTP du lead
                    await Api().post('/assurlead/lead/verify-phone', {
                        telephone_lead_agent: this.identifiant,
                        telephone: this.telephone_lead,
                        code: code
                    });
                    this.$toasted.show('Numéro du client vérifié avec succès.', this.ToastTabSucess);
                } else {
                    // Scénario 1: Vérification de l'OTP de l'agent
                    let agentNumber = this.lead_agent_number;
                    try {
                        const phoneNumber = parsePhoneNumberFromString(agentNumber);
                        if (phoneNumber && phoneNumber.isValid()) {
                            agentNumber = phoneNumber.nationalNumber;
                        }
                    } catch (e) { /* Ignorer l'erreur d'analyse, utiliser le numéro tel quel */ }
                    const phoneNumber = (this.countryCode + agentNumber).substring(1);
                    await Api().post('/assurlead/lead-agent/verify', {
                        telephone_lead_agent: phoneNumber,
                        code: code
                    });
                    this.$toasted.show('Numéro vérifié avec succès.', this.ToastTabSucess);
                }

                this.closeOtpDialog();
                await this.submitLead();

            } catch (error) {
                this.otpDigits = ['', '', '', '', '', ''];
                if (this.$refs.otpInput0) {
                    this.$refs.otpInput0[0].focus();
                }
                this.$toasted.show('Code OTP incorrect ou expiré.', this.ToastTabError);
            } finally {
                this.isOtpLoading = false;
            }
        },

        // Envoie les données du lead au backend (avec gestion des erreurs/loader)
        submitLead() {
            this.isLoading = true;
            const phoneNumberLeadAgent = this.identifiant || (this.countryCode + this.lead_agent_number).substring(1);
            let phoneNumberLead = (this.countryCode + this.telephone_lead).substring(1)
            const useMultipart = !!this.carte_grise_file || !!this.carte_grise_verso_file
            const payload = useMultipart ? new FormData() : {
                telephone_lead_agent: phoneNumberLeadAgent,
                nom_complet: this.lead_nom,
                telephone: phoneNumberLead,
                email: this.email_lead,
                immatriculation: this.immatriculation_lead,
                date_effet_souhaitee: this.date_effet_lead,
            }
            if (useMultipart) {
                payload.append('telephone_lead_agent', phoneNumberLeadAgent)
                payload.append('nom_complet', this.lead_nom)
                payload.append('telephone', phoneNumberLead)
                payload.append('email', this.email_lead || '')
                payload.append('immatriculation', this.immatriculation_lead || '')
                payload.append('date_effet_souhaitee', this.date_effet_lead || '')
                if (this.carte_grise_file) {
                    payload.append('carte_grise', this.carte_grise_file)
                }
                if (this.carte_grise_verso_file) {
                    payload.append('carte_grise_verso', this.carte_grise_verso_file)
                }
            }

            const canal = this.identifiant ? 'AssurLink' : 'Direct';
            if (useMultipart) {
                payload.append('canal', canal);
            } else {
                payload.canal = canal;
            }

            // Api de creation du lead
            const config = useMultipart ? { headers: { 'Content-Type': 'multipart/form-data' } } : useMultipart
            Api().post('/assurlead/create', payload, config)
                .then(response => {
                   if(response.status === 201){
                        this.$toasted.show(response.data.message, this.ToastTabSucess);
                        if (this.identifiant) {
                            this.$router.push('/');
                        } else {
                            this.resetForm();
                        }
                    }
                }).catch(error => {
                  if (error.response && error.response.status) {
                      if(error.response.status === 409){
                          this.$toasted.show('Cette demande de lead existe déjà', this.ToastTabError);
                      }else if(error.response.status === 403) {
                          this.numberVerification()
                      }
                  } else {
                      this.$toasted.show('Une erreur est survenue', this.ToastTabError);
                  }
                }).finally(() => {
                    this.isLoading = false;
                })
        },

        // Handler du bouton principal: valide le formulaire puis déclenche l'envoi
        sending_message() {
            // Validation rapide avant envoi
            this.runValidation()
            if (this.hasErrors || !this.isFormComplete) {
                this.$toasted.show('Veuillez corriger les champs en rouge', this.ToastTabError)
                return
            }

            if (this.identifiant) {
                // Scénario 2: L'agent est identifié, on vérifie le numéro du lead
                this.requestLeadOtp();
            } else {
                // Scénario 1: L'agent n'est pas identifié, on soumet et on attend une éventuelle demande de vérification (403)
                this.submitLead();
            }
        },
        // Remet le formulaire à zéro (champs + erreurs)
        resetForm() {
            this.currentStep = 1;
            this.telephone_lead = '';
            this.email_lead = '';
            this.lead_nom = '';
            this.immatriculation_lead = '';
            this.date_effet_lead = '';
            this.lead_agent_nom = '';
            this.lead_agent_number = '';
            this.carte_grise_file = null;
            this.carte_grise_verso_file = null;
            // Reset errors
            this.errors = {
                lead_agent_nom: null,
                lead_agent_number: null,
                lead_nom: null,
                immatriculation_lead: null,
                telephone: null,
                email_lead: null,
                carte_grise: null
            };
        }
    }

}
</script>

<style scoped>
  ::placeholder {
    /* Chrome, Firefox, Opera, Safari 10.1+ */
    font-size: 12px;
  }
.pro-form-card {
  background: #fff;
  border-radius: 16px;
  box-shadow: 0 10px 24px rgba(13, 78, 120, 0.15);
  padding: 20px;
  max-width: 880px;
  width: 100%;
  margin: 0 auto;
}

.pro-form-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding-bottom: 12px;
  border-bottom: 1px solid rgba(13, 78, 120, 0.12);
  margin-bottom: 16px;
}

.header-left {
  display: flex;
  align-items: center;
}

.titles .title {
  margin: 0;
  font-size: 18px;
  color: #0d4e78;
  font-weight: 700;
  line-height: 1.2;
}

.titles .subtitle {
  margin: 2px 0 0;
  font-size: 13px;
  color: #515457;
}

.badge {
  font-size: 12px;
  color: #0d4e78;
  background: rgba(13, 78, 120, 0.08);
  border: 1px solid rgba(13, 78, 120, 0.14);
  padding: 6px 10px;
  border-radius: 999px;
  display: inline-flex;          /* assure l’alignement vertical */
  align-items: center;
}

@media (max-width: 768px) {
  .badge {
    font-size: 11px;             /* compacte le badge sur petits écrans */
    padding: 6px 8px;
  }
  .header-right {
    gap: 8px;                    /* réduit l’espace pour tenir à côté */
  }
}
.header-right {
  display: inline-flex;          /* aligne badge et icône sur une ligne */
  align-items: center;
  gap: 10px;                     /* espace entre badge et X */
  white-space: nowrap;           /* évite le retour à la ligne sur mobile */
}

.badge {
  font-size: 12px;
  color: #0d4e78;
  background: rgba(13, 78, 120, 0.08);
  border: 1px solid rgba(13, 78, 120, 0.14);
  padding: 6px 10px;
  border-radius: 999px;
  display: inline-flex;
  align-items: center;
}

@media (max-width: 768px) {
  .badge {
    font-size: 11px;
    padding: 6px 8px;
  }
  .header-right {
    gap: 8px;                    /* réduit l’espace pour tenir à côté */
  }
}
.fields {
  margin-bottom: 10px;
}

.row {
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
}

.col-sm-12 { flex: 1 1 100%; }
.col-sm-6  { flex: 1 1 calc(50% - 12px); min-width: 260px; }
.col-sm-3  { flex: 1 1 calc(25% - 12px); min-width: 200px; }
.col-sm-4  { flex: 1 1 calc(30% - 12px); min-width: 200px; }

.field-group {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.field-label {
  font-weight: 600;
  color: #0d4e78;
  font-size: 13px;
}

.field-input,
.field-select,
textarea.field-input {
  width: 100%;
  height: 45px;
  border: 1px solid rgba(13, 78, 120, 0.22);
  border-radius: 10px;
  padding: 10px 12px;
  outline: none;
  transition: border-color 0.15s ease, box-shadow 0.15s ease;
  background: #fff;
  color: #1c2b36;
  font-size: 14px;
}

.field-input:focus,
.field-select:focus,
textarea.field-input:focus {
  border-color: #ffa409;
  box-shadow: 0 0 0 3px rgba(255, 164, 9, 0.18);
}

.success-alert {
  border-color: rgba(13, 78, 120, 0.22) !important;
}

.actions {
  display: flex;
  justify-content: flex-end;
  margin-top: 15px;
}

.send-btn {
  border-radius: 10px;
  background: #ffa409;
  color: #000000de;
}
.send-btn-confirm {
  border-radius: 10px;
  background: #ffa409;
  color: #000000de;
  height: 50px;
  width: 150px;
}



.valid-otp-btn {
  border-radius: 10px;
  background: #ffa409;
  color: #000000de;
}
.valid-otp-confirm {
  border-radius: 10px;
  background: #ffa409;
  color: #000000de;
  height: 50px;
  width: 150px;
}





.next-btn-active {
  /* background: #ffa409; */
  color: #ffa409;
  font-weight: 500;
  /* border-color: #ffa409; */
}

.step2-actions {
  justify-content: space-between;
}

.back-btn {
  /* background-color: #f5f5f5; */
  color: #333;
}

/* Responsive */
@media (max-width: 768px) {
  .pro-form-card {
    padding: 14px;
    border-radius: 14px;
  }
  .titles .title {
    font-size: 16px;
  }
  .titles .subtitle {
    font-size: 12px;
  }
  .col-sm-6, .col-sm-3 {
    flex: 1 1 100%;
  }
  .actions {
    justify-content: flex-end;
  }
  .send-btn {
    width: 100%;
  }
  .next-btn {
    min-width: 120px;
  }
}
.send-btn {
  display: inline-flex;
  align-items: center;
  gap: 12px;
  border-radius: 10px;
  background: #ffa409;
  color: #000000de;
  padding: 10px 24px;
  font-size: 16px;
  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.12);
  transition: transform 0.05s ease, box-shadow 0.2s ease, background-color 0.2s ease;
}
.send-btn:hover {
  box-shadow: 0 10px 24px rgba(0, 0, 0, 0.16);
}
.send-btn:disabled {
  opacity: 0.6;
  cursor: not-allowed;
  box-shadow: none;
}
.send-icon {
  color: #7a4e00;
  font-size: 26px;
}

@media (max-width: 768px) {
  .send-btn {
    width: 100%;
    height: 56px;
    justify-content: center;
  }
}
.phone-input-group {
  display: flex;
  align-items: center;
  gap: 0;
}
.phone-number-input {
  border-radius: 0 10px 10px 0;

}


.otp-card {
  border-radius: 20px !important;
  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.1) !important;
  position: relative;
  overflow: visible !important;
}

.otp-inputs-container {
  display: flex;
  justify-content: center;
  gap: 10px;
}

.otp-input {
  width: 50px;
  height: 50px;
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  text-align: center;
  font-size: 24px;
  font-weight: 600;
  color: #333;
  outline: none;
  transition: all 0.3s ease;
}

.otp-input:focus {
  border-color: #FFA409;
  box-shadow: 0 0 0 3px rgba(25, 118, 210, 0.2);
}

.otp-input.filled {
  border-color: #FFA409;
  background-color: #f0f7ff;
}


.otp-card .v-btn--icon {
  position: absolute;
  top: 15px;
  right: 15px;
  background: white !important;
  box-shadow: 0 2px 8px rgba(0,0,0,0.15);
  width: 32px !important;
  height: 32px !important;
  border-radius: 50% !important;
  z-index: 10;
}

.otp-card .v-btn--icon .v-icon {
  font-size: 18px;
  color: #555;
  font-weight: bold;
}

.otp-card .headline {
  color: #ffa409;
}

.otp-card .subheading {
  font-size: 14px !important;
  line-height: 1.5;
  padding: 0 10px;
}
.primary-color-assuraf {
  color: #ffa409;
}
.otp-dialog-max-width {
  max-width: 500px!important;
}
.otp-validate-button {
  border-radius: 8px;
  height: 50px;
}
.title-margin {
  margin-top: -10px;
}
.required {
  color: red;
  font-size: 13px;
}
.required-asterisk {
  color: red;
}
</style>